import { render } from "./accountInfoWs.vue?vue&type=template&id=4a67e86f&scoped=true"
import script from "./accountInfoWs.vue?vue&type=script&lang=js"
export * from "./accountInfoWs.vue?vue&type=script&lang=js"

import "./accountInfoWs.vue?vue&type=style&index=0&id=4a67e86f&scoped=true&lang=css"

import exportComponent from "D:\\xyzw\\springboot-vue-demo\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a67e86f"]])

export default __exports__